<template>
	<div class="day-selector">
		<div>Order For</div>
		<SkDropdownSelect
			v-model="selectedDay"
			:classes="'day-selector-dropdown'"
			:options="dayOptions"
			:iconClasses="''"
		/>
	</div>
</template>

<style>
.day-selector-dropdown .selected span {
	font-weight: 600;
	color: var(--gR-base-90);
	margin-right: 3px;
}

.day-selector-dropdown .option:not(.selected) {
	font-weight: 400;
}

.day-selector-dropdown .options {
	max-height: fit-content !important;
}
</style>

<style scoped>
.day-selector {
	display: flex;
	align-items: center;
	font-size: 14px;
}

.day-selector div:first-child {
	flex-shrink: 0;
	margin-right: 3px;
	color: var(--sk-grey3);
	font-weight: 400;
}
</style>

<script>
import moment from "moment"
import momentUtils from "@/moment-utils"
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"

export default {
	name: "ResidentialDaySelector",
	components: {
		SkDropdownSelect
	},
	computed: {
		startDate() {
			return this.$store.getters.residentialMenuStartDate
		},
		selectedDay: {
			get: function () {
				if (
					this.$store.state.deliveryDate &&
					this.$store.state.deliveryDate != null
				) {
					const deliveryDate = moment(
						this.$store.state.deliveryDate.date
					)
					const dow = momentUtils.normalizeDayOfWeek(deliveryDate)
					return this.dayOptions.find((option) => option.id == dow)
				} else {
					return null
				}
			},
			set: function (val) {
				if (val && val != null) {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Residential Day Selected",
						data: {
							date: val.date,
							start_date: this.startDate,
							dow: val.id
						}
					})
					this.$store.dispatch("setDeliveryDate", {
						date: val.date,
						preserveCart: true
					})
				}
			}
		},
		dayOptions() {
			const days = []
			const todaysDate = momentUtils.todaysDate()
			if (this.startDate != null) {
				for (var i = 0; i < 7; i++) {
					const date = moment(this.startDate, "YYYY-MM-DD").add(
						i,
						"day"
					)
					const dow = momentUtils.normalizeDayOfWeek(date)
					const isToday = momentUtils.isSameDay(date, todaysDate)
					days.push({
						id: dow,
						date: date.format("YYYY-MM-DD"),
						text: isToday ? "Today" : date.format("dddd")
					})
				}
			}
			return days
		}
	}
}
</script>